// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorService {
  Auto = 0,
  Norm = 1,
  Run = 2,
  Oos = 3,
  Ins = 4,
  InsCons = 5,
  CtIns = 6,
  CtInsCons = 7,
  CpIns = 8,
  CpInsCons = 9,
  HaIns = 10,
  HaInsCons = 11,
  MrIns = 12,
  MrInsCons = 13,
  MOS = 14,
  Ind = 15,
  Test = 16,
  TestSwitch = 17,
  FireMain = 18,
  FireAlt = 19,
  FirePhase1 = 20,
  FirePhase2 = 21,
  HospitalPhase1 = 22,
  HospitalPhase2 = 23,
  Shuttle = 24,
  Sabbath = 25,
  Construction = 26,
  Earthquake = 27,
  L = 28,
  Attendant = 29,
  CodeBlue = 30,
  Homing = 31,
  ResetGoingUp = 32,
  ResetGoingDown = 33,
  Stalled = 34,
  CarToLobby = 35,
  LoadBypass = 36,
  LoadWeighingOverload = 37,
  MedicalEmergency = 38,
  CalibrateLoadWeigher = 39,
  CarSwitchElevatorOff = 40,
  HallSwitchElevatorOff = 41,
  LowPressure = 42,
  HospitalServiceOperation = 43,
  VIP = 44,
  SecurityRecall = 45,
  TugServiceOperation = 46,
  HotOilOperation = 47,
  RiotControl = 48,
  CarSwitchElevatorOff2 = 49,
  Heliport = 50,
  Cfss0_Phase1 = 51,
  Cfss0_Transition = 52,
  Cfss0_Phase2 = 53,
  EMS_Phase1 = 54,
  Unknown = 55,
  NAV = 56,
  EmergencyMedicalTec = 57,
  EPC = 58,
  CorrectionRun = 59,
  EmergencyPowerReturn = 60,
  EmergencyPowerWait = 61,
  EmergencyPower = 62,
  OverloadedCar = 63,
  DoorTimeClose = 64,
  DoorTimeOpen = 65,
  CancelHallCalls = 66,
  LoadNonStop = 67,
  ModerateIncomingTraffic = 68,
  DoorCloseProtection = 69,
  AntiNusianceOperation = 70,
  ARD = 71,
  Parked = 72,
  Idle = 73,
  ParkingSwitch = 74,
  GCB = 75,
  Initializing = 76,
  EmergencyStopButton = 77,
  ACP = 78,
  WildCarOperation = 79,
  DriveBrakeFailure = 80,
  EFP = 81,
  CRL = 82,
  ConcealedRiserOperation = 83,
  CarEmergency = 84,
  DoorOpenSwitch = 85,
  WildCarService = 86,
  REC = 87,
  OHT = 88,
  ARE = 89,
  EPD = 90,
  JudgeCar = 91,
  EmergencyRecall = 92,
  Priority = 93,
  FirePreAlarm = 94,
  Night = 95,
  Building = 96,
  Special = 97,
  ServiceProtection = 98,
  StopSwitch = 99,
  DispatchLoss = 100,
  LobbyIndepedent = 101,
  DoorDisconnect = 102,
  RearDoorDisconnect = 103,
  ControlledShutdown = 104,
  DriveFault = 105,
  Initialization = 106,
  PowerLoss = 107,
  DriveOff = 108,
  Safeties = 109,
  Reset = 110,
  ShuntTrip = 111,
  LowOil = 112,
  Access = 113,
  NegativePressure = 114,
  AuxillaryPowerLanding = 115,
  Dead = 116,
  CriticalFail = 117,
  DownwardStall = 118,
  UpWardStall = 119,
  Disabled = 120,
  TestDisplay = 121,
  CloseFailure = 122,
  NoStarter = 123,
  StuckStarter = 124,
  CarCaptureSecurity = 125,
  Capture = 126,
  Security = 127,
  ViscosityCondition = 128,
  MedicalEmergencyPhase1 = 129,
  MedicalEmergencyPhase2 = 130,
  TelescopicResynchronizationInProgress = 131,
  TelescopicResynchronizationRecall = 132,
  ServiceDrive = 133,
  Freight = 134,
  PriorityLandingHigh = 135,
  PriorityLandingLow = 136,
  Simplex = 137,
  AutoReturnDrive = 138,
  LandingCallDisconnect = 139,
  PowerOk = 140,
  Started = 141,
  Stopping = 142,
  BrakeBurnishing = 143,
  Acceleration = 144,
  Deceleration = 145,
  Ready = 146,
  Continous = 147,
  CLS = 148,
  Stopped = 149,
  NormEnabled = 150,
  CounterWeightDerailment = 151,
  HomingAndShutdown = 152,
  HiWind = 153,
  Storm = 154,
  Reduced = 155,
  CCP1 = 156,
  CarCln = 157,
  OOSP1 = 158,
  Inv = 159,
  Prc = 160,
  HatchAccess = 161,
  CarHospital = 162,
  HallShutdownSwitch = 163,
  NoCommunication = 164,
  InitFailiure = 165,
  AutomaticShutdown = 166,
  StartProtect = 167,
  OverspeedFault = 168,
  BrakeFault = 169,
  MotionFault = 170,
  DoorZoneFault = 171,
  HallIndependentService = 172,
  CommunicationLossToGroup = 173,
  CarInGroupService = 174,
  DoorHoldActive = 175,
  MassMedInCar = 176,
  RunMonitorFailure = 177,
  FrontHoistDoorWatch = 178,
  SelectorFault = 179,
  RearHoistDoorWatchdog = 180,
  FrontCarDoorWatchdog = 181,
  RearCarDoorWatchdog = 182,
  FrontDoorNudging = 183,
  RearDoorNudging = 184,
  DiagnosticsCarLockout = 185,
  InitializationShutdown = 186,
  LoadweigherShutdown = 187,
  CheckedRedundancy = 188,
  CarCycling = 189,
  TelescopingJackResync = 190,
  InconspicuousRiser = 191,
  RetiringCamFailure = 192,
  NextUp = 193,
  TransferFloor = 194,
  FrontDoorHold = 195,
  RearDoorHold = 196,
  FrontDoorCommunicationLoss = 197,
  RearDoorCommunicationLoss = 198,
  ExternalControlOfCall = 199,
  ExternalControlOfFrontDoor = 200,
  ExternalControlOfRearDoor = 201,
  ExternalSecurity = 202,
  EmergencyDispatch = 203,
  NeoNatalService = 204,
  LobbyStop = 205,
  UnintendedMotion = 206,
  RescueOperation = 207,
  LoadWeighingByPass = 208,
  Earthquake2 = 209,
  SafetyStringOpen = 210,
  Cfss1_Phase1 = 211,
  Cfss1_Phase2 = 212,
  LobbyShutdownSwitch = 213,
  EmergencyPowerShutdown = 214,
  FireAlt2 = 215,
  EmergencyPowerSelected = 216,
  KeyOutOfService = 217,
  OverweightStop = 218,
  EmergencyHospitalRecall = 219,
  EmergencyHospitalInCar = 220,
  EPCarRecallFailed = 221,
  EPCarRecalledOK = 222,
  HallRecallOperation = 223,
  TUGAGVService = 224,
  AuxSelectionRelay = 225,
  CBP = 226,
  CDO = 227,
  CHN = 228,
  CandalOperation = 229,
  CarEmergencyService2 = 230,
  CardReaderOperation = 231,
  CutoffHallCall = 232,
  DelayedCarProtection = 233,
  DisabledDoorOperation = 234,
  DoorHoldButton = 235,
  DoorLockFailure = 236,
  DoorTimeProtectionClosed = 237,
  DoorTimeProtectionOpen = 238,
  DriveBreakFault = 239,
  ElectricalRecall = 240,
  EmergencyFiremansService = 241,
  EmergencyHospitalService = 242,
  EmergencyPowerRescue = 243,
  EmergencyPowerTransfer = 244,
  FireServiceShutdown = 245,
  GalMomMohDoorOperation = 246,
  HallButtonProtection = 247,
  InService = 248,
  InServiceParked = 249,
  IndependentServiceShutdown = 250,
  Initialize = 251,
  MTO = 252,
  NotAvailableFaulted = 253,
  OverloadDevice = 254,
  ParkingShutdown = 255,
  RiotOperation = 256,
  SeismicOperation = 257,
  SeparateRiserOperatation = 258,
  WCS = 259,
  EMK = 260,
  Gap = 261,
  InServiceNoDemand = 262,
  PFO = 263,
  VandalOperation = 264,
  _50 = 265,
  _51 = 266,
  _52 = 267,
  _53 = 268,
  _54 = 269,
  _55 = 270,
  _56 = 271,
  _57 = 272,
  _58 = 273,
  _59 = 274,
  _60 = 275,
  _61 = 276,
  _62 = 277,
  _63 = 278,
  _64 = 279,
  _65 = 280,
  _66 = 281,
  _67 = 282,
  _68 = 283,
  _69 = 284,
  _70 = 285,
  _71 = 286,
  _72 = 287,
  _73 = 288,
  _74 = 289,
  _75 = 290,
  _76 = 291,
  _77 = 292,
  _78 = 293,
  _79 = 294,
  _80 = 295,
  _81 = 296,
  _82 = 297,
  _83 = 298,
  _84 = 299,
  _85 = 300,
  _86 = 301,
  _87 = 302,
  _88 = 303,
  _89 = 304,
  _90 = 305,
  _91 = 306,
  _92 = 307,
  _93 = 308,
  _94 = 309,
  _95 = 310,
  _96 = 311,
  _97 = 312,
  _98 = 313,
  _99 = 314,
  _100 = 315,
  _101 = 316,
  _102 = 317,
  _103 = 318,
  _104 = 319,
  _105 = 320,
  _106 = 321,
  _107 = 322,
  _108 = 323,
  _109 = 324,
  _110 = 325,
  _111 = 326,
  _112 = 327,
  _113 = 328,
  _114 = 329,
  _115 = 330,
  _116 = 331,
  _117 = 332,
  _118 = 333,
  _119 = 334,
  _120 = 335,
  _121 = 336,
  _122 = 337,
  _123 = 338,
  _124 = 339,
  _125 = 340,
  ANS = 341,
  CES = 342,
  CRO = 343,
  DLF = 344,
  DOS = 345,
  DDO = 346,
  EPO = 347,
  EPT = 348,
  ERO = 349,
  IDL = 350,
  INI = 351,
  NOR = 352,
  PRK = 353,
  SCO = 354,
  SCX = 355,
  AlternateFire = 356,
  MainFire = 357,
  MaHospitalService = 358
}
